import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// Referans provizyon sayfalarında, ortak bileşenlerin çağırdığı normal provizyon endpoint'lerini
// ReferansProvizyonVakif / ReferansProvizyonShy controller'larına yönlendirir. Referans controller'ları
// aynı action/route/parametreleri sunar; tek fark referans menüsü (7538) ile yetkilendirilmeleridir.
const ORTAK_ACTIONLAR = [
  "ProvizyonKaydet", "ProvizyonGetir", "TevkifatLimitTutarTarihGuncelle", "ProvizyonSil",
  "ProvizyonKurumAciklamaGuncelle", "IslemTipKaydet", "IslemTipGetir", "IslemTipListesi",
  "IslemTipSil", "ProvizyonFaturaIslemTipKontrol", "IslemTipGuncelle", "IslemTipIcd10Kaydet",
  "IslemTipIcd10Sil", "IslemTipIcd10Listesi",
];
const AYAKTA_ACTIONLAR = [
  "IlacMalzemeListesi", "IlacMalzemeKaydet", "MuayeneVarMi", "AyaktaTedaviHizmetListesi",
  "ProvizyonFaturaAyaktaTedaviKaydet", "ProvizyonFaturaAyaktaTedaviGuncelle",
  "ProvizyonFaturaAyaktaTedaviSilme", "ProvizyonFaturaAyaktaTedaviListesi",
  "ProvizyonFaturaAyaktaTedaviGetir",
];

interface Yonlendirme {
  kaynak: string;
  hedef: string;
  desen: RegExp;
}

function yonlendirme(kaynak: string, hedef: string, actionlar: string[]): Yonlendirme {
  return { kaynak, hedef, desen: new RegExp(`/${kaynak}/(${actionlar.join("|")})(?=[/?]|$)`) };
}

const YONLENDIRMELER: Yonlendirme[] = [
  yonlendirme("VakifIcinOrtak", "ReferansProvizyonVakif", [...ORTAK_ACTIONLAR, "OzelIslemTipSil"]),
  yonlendirme("AyaktaTedaviVakif", "ReferansProvizyonVakif", AYAKTA_ACTIONLAR),
  yonlendirme("ShyIcinOrtak", "ReferansProvizyonShy", ORTAK_ACTIONLAR),
  yonlendirme("AyaktaTedaviShy", "ReferansProvizyonShy", [...AYAKTA_ACTIONLAR, "SgkTutariSifirla", "SgkTutariHesapla"]),
];

// Referans provizyon sayfaları (Fatura-Provizyon/referans-...). Sorgula ekranı kendi API'sini kullanır.
export function referansSayfasiMi(): boolean {
  const yol = window.location.pathname;
  return yol.startsWith("/Fatura-Provizyon/referans-") && !yol.startsWith("/Fatura-Provizyon/referans-provizyon-sorgula");
}

@Injectable({
  providedIn: "root",
})
export class ReferansProvizyonInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!referansSayfasiMi()) {
      return next.handle(req);
    }

    for (const y of YONLENDIRMELER) {
      if (y.desen.test(req.url)) {
        return next.handle(req.clone({ url: req.url.replace(`/${y.kaynak}/`, `/${y.hedef}/`) }));
      }
    }
    return next.handle(req);
  }
}
